import React, { useEffect, useState } from "react";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/pagination';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import educationImg from "../../../assets/images/education.png";
import { FreeMode, Navigation, Thumbs } from "swiper";
import { Tabs } from "antd";
import AboutBg from "../../../assets/images/about_bg.png"
import CoreHttpHandler from "../../../http/services/CoreHttpHandler";
import { Box, LinearProgress } from "@mui/material";

const Sec6 = ({ recent, loading }) => {

	// const [index, setIndex] = useState(0);
	const [aboutUs, setAboutUs] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const getAboutUs = () => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"about",
			"fetchAboutUs",
			{},
			(res) => {
				setAboutUs(res.data.data.about)
				setIsLoading(false)
				// ToastAlertSuccess("Item removed Successfully");
			},
			(err) => {
				// ToastAlertError(
				// 	err?.response?.data?.message
				// 		? err?.response.data.message
				// 		: "something went wrong"
				// );
			}
		);
	};



	useEffect(() => {
		getAboutUs()
	}, [])

	return (
		<>

			<section className='sec sec6'>
				<div className='container'>

					{isLoading ?
						<Box sx={{ my: '5rem' }}>
							<LinearProgress color="success" />
						</Box>
						:

						aboutUs.map((e,i) => {
							return <>

								<div className="img_div">
									<img src={e.img} loading="lazy" />
								</div>
								<div className="txt_div">
									<h2>{e.title}</h2>
									<p style={{fontSize:"18px"}}><td dangerouslySetInnerHTML={{__html: e.description}} /></p>
									{/* <p>Discover E Governance Online: Your Gateway to Empowered Shareholding!<br /><br />

										A collaborative initiative by the Pakistan Institute of Corporate Governance (PICG) and the Central Depository Company of Pakistan (CDC), E Governance Online aims to elevate shareholder awareness and understanding of their rights and responsibilities. Our mission is to provide an engaging, user-friendly platform that empowers shareholders with essential information on corporate governance practices.
										<br /><br />
										E Governance Online is your go-to hub for resources, training, and learning modules tailored for shareholders at all experience levels. Beyond educational content, E Governance Online offers tools to actively participate in corporate governance through e-Meetings, e-Voting, and e-Proxy, enabling informed and impactful decision-making.
										<br /><br />
										Accessible in both Urdu and English, our portal ensures inclusivity for all. Dive into a wealth of knowledge and become a proactive shareholder with E Governance Online!
									</p> */}
								</div>

							</>
						})
					}

				</div>
			</section>
		</>
	);
};

export default Sec6;
